/**
 * default format for typo3 data:
 * { sections: [{
 *     sectionTitle: "string",
 *     items: [{ title: "string",
 *        subtitle: "string",
 *        src: "path to img",
 *        link: "path for click event"
 *     }]
 * }]
 * }
 *
 * In cases where only one section is meaningful, that section is the top element, e.g. ProduktePrivat.
 * The properties are used differently, sometimes ignored, especially src, subtitle.
 *
 * Top level format is different for About Auszeichnungen and About Unternehmen.
 *
 */

export default {
  StartseiteNews: {
    sectionTitle: "NEWS",
    items: [
      {
        title: 'Beitragsgarantie',
        subtitle: 'bis Ende 2019',
        link: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/Ohne.pdf'
      },
      {
        title: 'Auszeichnungen und Bestnoten',
        subtitle: 'für Makler-Service und Produkte',
        link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      },
      {
        title: 'NEU Cyber-Schutz',
        subtitle: 'vor Gefahren aus dem Netz',
        link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      },
      {
        title: 'Neuer Tarif 2018',
        subtitle: 'Highlights im Recht: aktuell',
        link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      },
      {
        title: 'Der persönliche Vorsorge-Assistent',
        subtitle: 'für Ihre Kunden',
        link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      },
      {
        title: 'Makler-Champion 2022',
        subtitle: 'DMB Rechtsschutz erneut unter Top 5',
        link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },
  StartseiteAuszeichnungen: {
    items: [
      {
        src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg',
        link: 'http://www.franke-bornberg.de/'
      },
      {
        src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg',
        link: ''
      },
      {
        src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg',
        link: ''
      }
    ]
  },
  ProduktePrivat: {
    "sectionTitle":"Privatkunden-RS",
    "items":[
      {
        "link":"https://www.dmbrsv-test.de/dmbtest/fileadmin/mp/pdf/produkte/privat/dmbrs-lvg-sta-exp-pre-0120.pdf",
        "title":"Leistungsvergleich Privat-Rechtsschutz"
      }
    ]
  },
  ProduktePrivatWeitere: {
    sections: [
      {
        sectionTitle: "Weitere Unterlagen",
        items: [
          {
            title: 'Deckungsauftrag Privatkunden-RS',
            link: 'https://drive.google.com/open?Titel=da&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Deckungsauftrag Privatkunden-Charta-RS',
            link: 'https://drive.google.com/open?Titel=charta_da&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Kundeninfo AVI + ARB 2024',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Kundeninfo AVI + ARB Schnell & Sicher 2024',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Kundeninfo AVI + ARB YOLIG 2024',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Leistungsvergleich Privatkunden Rechtsschutz',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  ProdukteGewerbe: {
    sections: [
      {
        sectionTitle: 'Anträge/ARB/iPID',
        items: [
          {
            title: 'Deckungsauftrag Gewerbe-RS',
            link: 'https://drive.google.com/open?titel=deckungsauftrag_gw&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Deckungsauftrag Gewerbe-Charta-RS',
            link: 'https://drive.google.com/open?titel=deckungsauftrag_charta_gw&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'

          },
          {
            title: 'Kundeninfo AVI + ARB 2024',
            link: 'https://drive.google.com/open?titel=kundeninfo_&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Kundeninfo Charta AVI + ARB 2024',
            link: 'https://drive.google.com/open?titel=kundeninfo_charta_&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'KOMPEX Leistungen und Beiträge',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'KOMPEX Produktinformationen',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Maklerinfo Gewerbe-RS',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Maklerinfo SSR',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Deckungsauftrag Vereins-RS',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Maklerinfo Vereins-Rechtsschutz',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  ProdukteKomedex: {
    sections: [
      {
        sectionTitle: 'Anträge/ARB/iPID',
        items: [
          {
            title: 'Deckungsauftrag KOMedEX',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'KOMedEX RS Info',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'KOMedEX Leistungsmerkmale und Beiträge',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Kundeninfo AVI + ARB 2024',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  ProdukteAgromex: {
    sections: [
      {
        sectionTitle: 'Anträge/ARB/iPID',
        items: [
          {
            title: 'Deckungsauftrag AGROMEX',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'AGROMEX Highlights und Tarifblatt',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Kundeninfo AVI + ARB 2024',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  ProdukteService: {
    sections: [
      {
        sectionTitle: 'Service für Kunden',
        items: [
          {
            title: 'DMB RECHT Serviceleistungen',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Rechtliche persönliche Vorsorge',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'DMB RECHT Forderungshilfe für Vermieter',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'DMB RECHT Forderungshilfe für Geschäftskunden',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Psychologische Soforthilfe nach Cyber-Mobbing ',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Monitoring persönlicher Daten',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  VertriebRechtAktuell: {
    sections: [
      {
        sectionTitle: 'Recht: aktuell',
        items: [
          {
            title: 'Beiträge garantiert stabil 10/2018',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Unabhängiger Rechtsschutz-Partner 01/2018',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Attraktive Prämien nutzen 10/2017',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Ihre Kunden wollen Rechtsschutz 03/2017',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Leistungen deutlich verbessert 08/2016',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  VertriebSEPA: {
    sections: [
      {
        sectionTitle: 'SEPA',
        items: [
          {
            title: 'SEPA Informationen',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'SEPA Basismandat',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  VertriebVerkaufshilfen: {
    sections: [
      {
        sectionTitle: 'Verkaufshilfe/Schadenbeispiele',
        items: [
          {
            title: 'Verkaufshilfe Privatkunden Grafik',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Verkaufshilfe Privatkunden Tabelle',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Cyber-Rechtsschutz Highlights',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Cyberrisiko: Rechtsschutz-Thema 05/2018',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Gefahr aus dem Netz 03/2018',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Rechtsschutz für Geschäftskunden',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Maklerinformation Geschäftskunden',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Maklerinformation Spezial-Straf-Rechtsschutz',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'DMB RECHT Serviceleistungen',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Persönlicher Vorsorge-Assistent für Ihre Kunden',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Auszeichnungen und Bestnoten für Makler-Service',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Rechtsschutz: Großes Potenzial 10/2017',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Ihre Kunden wollen Rechtsschutz 03/2017',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  AboutUnternehmen: {
    downloadsBox: {
      sectionTitle: "Downloads",
      items: [
        {
          title: 'Leistungsmerkmale DMB Rechtsschutz ',
          subtitle: '04/2018',
          link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
        },
        {
          title: 'Geschäftsbericht ',
          subtitle: '2017',
          link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
        }
      ]
    },
    content: {
      sections: [
        {
          sectionTitle: "Unternehmen: Der konzernunabhängige Rechtsschutz-Spezialist",
          items: [
            {
              title: "Rechtsschutz-Profi seit 1982 mit etwa 800.000 Kunden"
            },
            {
              title: "Über zehn Jahre im Maklermarkt"
            },
            {
              title: '"Ausgezeichnet" im Ascore Unternehmens-Scoring Komposit als eine der besten Rechtsschutz-Gesellschaften'
            },
            {
              title: "Hohe Servicequalität bei Policierung, Courtageabwicklung, Schadenbearbeitung"
            },
            {
              title: "Niedrige Beschwerdequote dank zufriedener Kunden"
            }
          ]
        },
        {
          sectionTitle: "Produkte: Hervorragendes Preis-Leistungs-Verhältnis",
          items: [
            {
              title: "Einfache, übersichtliche Produktstruktur"
            },
            {
              title: "Drei Produktlinien für Privatkunden für bedarfsgerechte Absicherung: Standard, EXPERT, PRESTIGE"
            },
            {
              title: "Umfassende Komplettpakete für Geschäftskunden: KOMPEX, KOMedEX, AGROMEX"
            },
            {
              title: "Flexible Absicherung: Privat, Beruf, Verkehr, Wohnen"
            },
            {
              title: "Verschiedene SB-Varianten für preissensitive Kunden"
            },
            {
              title: "Zahlreiche Auszeichnungen für leistungsstarke Produkte"
            }]
        },
        {
          sectionTitle: "Serviceangebote: Wertvolle Hilfe für Kunden",
          items: [
            {
              title: "Schon bevor ein Rechtsstreit entsteht und wenn schnelle Hilfe nötig ist"
            },
            {
              title: "DMB RECHT-Hotline und -Mail für alle rechtlichen Fragen"
            },
            {
              title: "Bei Cyber: Psychologische Soforthilfe bei Cyber-Mobbing und vorbeugende Hilfe"
            },
            {
              title: "Rechtliche persönliche Vorsorge: Vorsorge-Verfügung online"
            },
            {
              title: "DMB RECHT Forderungshilfe: Professionelles Forderungsmanagement"
            },
            {
              link: "Ohne.pdf",
              title: "Immer ohne Wartezeit und ohne Anrechnung als Schadenfall"
            }]
        },
        {
          sectionTitle: "Vertriebspartner: Vielfältige Beratung und Betreuung",
          items: [
            {
              link: "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/dmb/BFV_Logo_gesamt_grau.png",
              subtitle: "Gründungsmitglied der <a target='_blank' href='https://www.bfv-versicherungsmakler.de/start/'>Bundesarbeitsgemeinschaft zur Förderung der Versicherungsmakler (BFV)</a>",
              title: "Gründungsmitglied der Bundesarbeitsgemeinschaft zur Förderung der Versicherungsmakler (BFV)"
            },
            {
              title: "Regelmäßige Online-Schulungen zu verschiedenen Themen"
            },
            {
              title: "Verkaufshilfen mit Schadenbeispielen aus der Praxis"
            },
            {
              title: "Modernes, übersichtliches Maklerportal"
            },
            {
              title: "Haftungssicherheit durch innovative Produkte, z.B. Upgrade-Garantie (garantierter Einschluss von prämienneutralen Leistungserweiterungen/-verbesserungen)"
            }]
        }
      ]
    }
  },
  AboutPresse: {
    sections: [
      {
        sectionTitle: 'Presse',
        items: [
          {
            title: 'Pressemitteilung Geschäftsentwicklung 04/2018',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Als Maklerpartner bestätigt 04/2018 ',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Cyber-Risiko: Rechtsschutz-Thema 05/2018 ',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Zuverlässiger Maklerpartner 09/2017 ',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Wachstum im Maklergeschäft 04/2016',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          },
          {
            title: 'Beratungsansatz Anwaltshotline 07/2016',
            link: 'https://drive.google.com/open?id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
          }
        ]
      }
    ]
  },
  AboutAuszeichnungen: {
    unternehmenText: {
      sections: [
        {
          sectionTitle: '',
          items: [
            { title: 'ascore Unternehmens-Scoring Komposit: Bestnoten 2016-2018' },
            { title: 'vt-Partnerschaftsspiegel 2018 (versicherungstip): Zuverlässiger Maklerpartner' },
            { title: 'MAKLER CHAMPION in 2011 - 2017: Top 10 der servicestärksten Rechtsschutz-Versicherer' },
            { title: 'FOCUS MONEY 13/2017: Top 5 der fairsten Makler-Versicherer Rechtsschutz' },
            { title: '2009 erster Rechtsschutz-Versicherer mit Prüfsiegel Arbeitskreis Beratungsprozesse' }
          ]
        }
      ],
    },
    unternehmenBadges: [
      { src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg' },
      { src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg' },
      { src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg' }
    ],
    produkteText: {
      sections: [
        {
          sectionTitle: '2018',
          items: [
            { title: 'ascore Das Scoring 05/2018: EXPERT und PRESTIGE "ausgezeichnet" mit 5 und 5,5 Sternen' },
            { title: 'Handelsblatt-Vergleich 03/2018: PRESTIGE "sehr gut" (Familie)' },
            { title: 'F+B Rechtsschutz-Rating 02/2018: PRESTIGE/+Cyber: FFF "hervorragend", EXPERT/+Cyber: FF "gut"' }
          ]
        },
        {
          sectionTitle: '2017',
          items: [
            { title: 'Softfair Rechtsschutz-Rating 2017: PRESTIGE 3x "hervorragend", EXPERT 3x "sehr gut"' },
            { title: 'Handelsblatt-Vergleich 06/2017: PRESTIGE "sehr gut"' },
            { title: 'ascore Das Scoring 05/2017: PRESTIGE "ausgezeichnet", EXPERT "sehr gut"' },
            { title: 'F+B Rechtsschutz-Rating 2/2017: PRESTIGE - FFF "hervorragend", EXPERT - FF "gut"' }
          ]
        },
        {
          sectionTitle: '2016',
          items: [
            {
              title: 'DtGV + N24 Rechtsschutz-Test 2016: Kundendienst Telefon - Note 1,2 "sehr gut"; ' +
                'Tarif Privat, Beruf & Verkehr "gut"'
            },
            { title: 'ascore Das Scoring 05/2016: PRESTIGE "ausgezeichnet", EXPERT "sehr gut"' },
            { title: 'Softfair Rechtsschutz-Rating 2016: PRESTIGE 2x "hervorragend", EXPERT 3x "sehr gut"' }
          ]
        },
        {
          sectionTitle: 'bis 2015',
          items: [
            { title: '€URO 01/2015: EXPERT und PRESTIGE bei den besten Rechtsschutz-Angeboten' },
            { title: 'Finanztest/Stiftung Warentest12/2014: PRESTIGE "gut"' },
            { title: 'FOCUS MONEY 14/2014: PRESTIGE bei den Top 5 Premiumtarifen' },
            { title: '€URO 01/2014: Note 1,9 für EXPERT-Tarif mit SB' },
            { title: 'ÖKO-TEST 01/2014: EXPERT mit SSR und PRESTIGE mit SSR auf Rang 2' },
          ]
        }
      ]
    },
    produkteBadges: [
      { src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg' },
      { src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg' },
      { src: 'https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/templates/images/imghome/zMPfVP18-p__dpx.jpg' }
    ]
  },
  ARB: {
    sectionTitle: "ARB",
    items: [
      {
        title: "ARB",
        link: 'https://drive.google.com/open?titel=ARB&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },  
  ARB_SUS: {
    sectionTitle: "ARB Schnell & Sicher",
    items: [
      {
        title: "ARB Schnell & Sicher",
        link: 'https://drive.google.com/open?titel=ARB-SUS&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },  
  ARB_YOLIG: {
    sectionTitle: "ARB YOLIG",
    items: [
      {
        title: "ARB YOLIG",
        link: '#PLATZHALTER_YOLIG'
      }
    ]
  },
  PI_Standard: {
    sectionTitle: "Produktinformationen Standard",
    items: [
      {
        title: "Produktinformationen Standard",
        link: 'https://drive.google.com/open?titel=STD&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },
  PI_EXPERT: {
    sectionTitle: "Produktinformationen EXPERT",
    items: [
      {
        title: "Produktinformationen EXPERT",
        link: 'https://drive.google.com/open?titel=EXP&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },
  PI_SUS: {
    sectionTitle: "Produktinformationen Schnell & Sicher",
    items: [
      {
        title: "Produktinformationen  Schnell & Sicher",
        link: 'https://drive.google.com/open?titel=SUS&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },
  PI_PRESTIGE: {
    sectionTitle: "Produktinformationen PRESTIGE",
    items: [
      {
        title: "Produktinformationen PRESTIGE",
        link: 'https://drive.google.com/open?titel=EXP&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },
  PI_YOLIG: {
    sectionTitle: "Produktinformationen YOLIG",
    items: [
      {
        title: "Produktinformationen YOLIG",
        link: '#PLATZHALTER_YOLIG'
      }
    ]
  },
  HL_Standard: {
    sectionTitle: "Highlightblatt Standard",
    items: [
      {
        title: "Highlight-Blatt Standard",
        link: 'https://www.dmbrsv-test.de/dmbtest/fileadmin/mp/pdf/produkte/privat/dmb-rs_sta-hl_0120.pdf'
      },
      {
        title: "Highlight-Blatt Standard ohne Beiträge",
        link: 'https://www.dmbrsv-test.de/dmbtest/fileadmin/mp/pdf/produkte/privat/dmb-rs_sta-hl_0120_s1.pdf'
      }
    ]
  },
  HL_EXPERT: {
    sectionTitle: "Highlightblatt EXPERT",
    items: [
      {
        title: "Highlight-Blatt EXPERT",
        link: 'https://www.dmbrsv-test.de/dmbtest/fileadmin/mp/pdf/produkte/privat/dmb-rs_exp-hl_0120.pdf'
      },
      {
        title: "Highlight-Blatt EXPERT ohne Beiträge",
        link: 'https://www.dmbrsv-test.de/dmbtest/fileadmin/mp/pdf/produkte/privat/dmb-rs_exp-hl_0120_s1.pdf'
      }
    ]
  },
  HL_SUS: {
    sectionTitle: "Highlightblatt Schnell & Sicher",
    items: [
      {
        title: "Highlightblatt Schnell & Sicher",
        link: 'https://drive.google.com/open?titel=HLSUS&id=1lnE2DBJCVIDsDDdeKifM10XnK3XTPeY5'
      }
    ]
  },
  HL_PRESTIGE: {
    sectionTitle: "Highlightblatt Schnell & Sicher",
    items: [
      {
        title: "Highlight-Blatt PRESTIGE",
        link: 'https://www.dmbrsv-test.de/dmbtest/fileadmin/mp/pdf/produkte/privat/dmb-rs_pre-hl-tf.bl.-0120.pdf'
      }
    ]
  },
  HL_YOLIG: {
    sectionTitle: "Highlightblatt YOLIG",
    items: [
      {
        title: "Highlight-Blatt YOLIG",
        link: '#PLATZHALTER_YOLIG'
      }
    ]
  }
  
};
